<template>
  <div>
    <PostSigning
      heading="Successful signing session"
      message="Lad Pirate Round yard rigging lugsail run a shot across the bow. Shiver me timbers maroon ye blow the man down."
      type="success"
      class="!h-auto pb-10"
    />
    <PostSigning
      heading="Buccaneer pinnace belaying pin Sea Legs"
      messageIntro="Chase guns holystone stern grog bucko jib American Main loaded to the gunwalls grapple main sheet."
      message="Draft coffer main sheet long boat hulk lee yawl trysail prow walk the plank."
      type="warning"
      class="!h-auto pb-10"
    />
    <PostSigning
      heading="Something went wrong"
      messageIntro="Tack Jolly Roger topsail reef sails strike colors pillage tackle squiffy interloper Arr."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="error"
      class="!h-auto pb-10"
    />
    <PostSigning
      heading="Successful signing session"
      messageIntro="Chase guns holystone stern grog bucko jib American Main loaded to the gunwalls grapple main sheet."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="success"
      class="!h-auto pb-10"
      :loading="true"
    />
    <PostSigning
      heading="Successful signing session"
      messageIntro="Lad Pirate Round yard rigging lugsail run a shot across the bow."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="success"
      class="!h-auto pb-10"
      :loading="loading"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'

import PostSigning from '@/components/screens/PostSigningScreen.vue'

const loading = ref(true)

setInterval(() => { loading.value = !loading.value }, 5000)
</script>
